<app-pageheader [Parent]="this">
  @if (CanWrite && ModelIsNew==false) {
    <app-form-delete-button [Parent]="this" [Form]="Form" [Model]="Model"
      DeleteUrl="enforcement/citation-exemption-lists/"
      DeleteNavLink="/enforcement/citation-exemption-lists" [DeleteCheck]="false">
    </app-form-delete-button>
  }
  @if (CanWrite && ModelIsNew==false && Model?.Id) {
    <span class="mr-3">
      <add-button (click)="OpenEntry(null)" ButtonText="Add Plate"></add-button>
    </span>
  }
  @if (CanWrite) {
    <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
    </app-form-save-button>
  }
</app-pageheader>

<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <div class="columns">
      <div class="column is-full">
        <article class="panel">
          <p class="panel-heading">Citation Exemption List</p>
          <div class="panel-block is-block">
            <div class="columns">
              <div class="column is-7">
                <app-field Label="Name" [InputPadding]="true">
                  <div class="control">
                    <input formControlName="Name" class="input" type="text" placeholder="Enter list name" />
                    <app-validator [For]="Form.get('Name')"></app-validator>
                  </div>
                </app-field>
                <app-field Label="Description">
                  <div class="control">
                    <textarea formControlName="Description" class="textarea" placeholder="Optional description" rows="3"></textarea>
                    <app-validator [For]="Form.get('Description')"></app-validator>
                  </div>
                </app-field>
              </div>
              <div class="column is-5">
                <app-field Label="Expiry Date" [InputPadding]="true">
                  <div class="control">
                    <input formControlName="ExpiresOnLocal" class="input" type="date" />
                  </div>
                </app-field>
                <app-field Label="Active">
                  <div class="control">
                    <label class="checkbox">
                      <input type="checkbox" formControlName="IsActive" />
                    </label>
                    <p class="help">When disabled, no plates in this list will be exempt from citations.</p>
                  </div>
                </app-field>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>

    <div class="columns">
      <div class="column is-full">
        <article class="panel">
          <p class="panel-heading">Plate Entries</p>
          <div class="panel-block is-block">
            @if (!ModelIsNew && Model?.Id) {
              <app-datalistview [Columns]="EntryColumns" [ShowMap]="false"
                [ApiUrl]="'enforcement/citation-exemption-lists/' + Model.Id + '/entries/searches'"
                [AllowCustomAction]="CanWrite" [CustomAction]="OpenEntry.bind(this)" CustomActionText="Edit"
                [AllowDelete]="CanWrite" [DeleteAction]="DeleteEntry.bind(this)">
                <app-filter-set>
                  <div app-search-filter></div>
                  <div app-search-button></div>
                </app-filter-set>
              </app-datalistview>
            }
            @if (ModelIsNew) {
              <div class="box">
                The list must be saved before plate entries can be added.
              </div>
            }
          </div>
        </article>
      </div>
    </div>
  </div>
}
